import { useRootSelector } from '../../../../../../../../store/hooks';
import { selectSitePricingPackagesMeta } from '../../../../../../store/features/packages';
import SummaryTotals from '../../../../OrderSummary/components/SummaryTotals';

export default function TotalPrice() {
  const { totalPrice } = useRootSelector(selectSitePricingPackagesMeta);

  return <SummaryTotals totalPrice={totalPrice} titleVariant="smallText" />;
}
